export default "__VITE_ASSET__CKODCzT2__"